<template>
  <div id="app">
    <div>
      <NetworkChecker />
    </div>
    <AppAnnouncementsHost
      :announcements="visibleAnnouncements"
      mode="top"
      @click="handleAnnouncementClick"
      @dismiss="handleAnnouncementDismiss"
      @acknowledge="handleAnnouncementAcknowledge"
    />
    <button type="button" class="btn btn-primary visually-hidden" data-bs-toggle="modal"
      data-bs-target="#userSecurityModal" id="checkSecurityBtn">
      Open
    </button>
    <UserSecurityChecker />
    <Loader />
    <router-view />
    <HardwareServiceChecker/>
    <AppAnnouncementsHost
      :announcements="visibleAnnouncements"
      mode="modal"
      @click="handleAnnouncementClick"
      @dismiss="handleAnnouncementDismiss"
      @acknowledge="handleAnnouncementAcknowledge"
    />
  </div>
</template>
<script>
import Loader from "@/components/layout/Loader";
import UserSecurityChecker from "@/components/UserSecurityChecker.vue";
import NetworkChecker from "@/components/layout/NetworkChecker.vue";
import store from "@/store";
import HardwareServiceChecker from "@/components/layout/HardwareServiceChecker.vue";
import AppAnnouncementsHost from "@/components/layout/announcements/AppAnnouncementsHost.vue";
import { announcementsService } from "@/services/announcements.service";

export default {
  components: {AppAnnouncementsHost, NetworkChecker, HardwareServiceChecker, UserSecurityChecker, Loader},
  data() {
    return {
      visibleAnnouncements: [],
      name: this.$route.name,
      resizeListener: (e) => this.$store.commit('setWindowWidth'),
    }
  },
  async beforeMount() {
    if (!store.getters.isHydrated) {
      await new Promise((resolve) => {
        const interval = setInterval(() => {
          if (store.getters.isHydrated) {
            clearInterval(interval);
            resolve();
          }
        }, 50);  // Check every 50ms
      });
    }
    if (!routeExceptions.includes(this.name)) {
      await this.$store.dispatch('syncData');
      await this.fetchAnnouncements();
    }
  },
  created() {
    window.addEventListener('resize', this.resizeListener)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.resizeListener)
  },
  methods: {
    async fetchAnnouncements() {
      try {
        this.visibleAnnouncements = await announcementsService.fetchVisibleAnnouncements();
      } catch (error) {
        console.warn("[announcements] failed to fetch", error);
      }
    },
    async handleAnnouncementClick(announcement) {
      try {
        const context = await announcementsService.resolveContext();
        await announcementsService.trackAnnouncementClick(announcement.id, context);
        if (announcement.link) {
          window.openUrl(announcement.link);
        }
      } catch (error) {
        console.warn("[announcements] click tracking failed", error);
      }
    },
    async handleAnnouncementDismiss(announcement) {
      try {
        const context = await announcementsService.resolveContext();
        await announcementsService.dismissAnnouncement(announcement.id, context);
        this.visibleAnnouncements = this.visibleAnnouncements.filter(a => a.id !== announcement.id);
      } catch (error) {
        console.warn("[announcements] dismiss failed", error);
      }
    },
    async handleAnnouncementAcknowledge(announcement) {
      try {
        const context = await announcementsService.resolveContext();
        await announcementsService.acknowledgeAnnouncement(announcement.id, context);
        this.visibleAnnouncements = this.visibleAnnouncements.filter(a => a.id !== announcement.id);
      } catch (error) {
        console.warn("[announcements] acknowledge failed", error);
      }
    },
  },
  computed: {
    loading() {
      return this.$store.getters.getLoadingState;
    },
    isOpen() {
      return this.$store.getters.isUserSecurityOpen
    }
  },
  watch: {
    isOpen: function (isOpen, wasOpen) {
      if (isOpen) {
        this.$nextTick(() => {
          document.getElementById('checkSecurityBtn').click()
        })
      }
    }
  }
}
</script>
<style lang="scss">
@import "assets/css/styles";
</style>